import _ from 'lodash';
import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useSnackbar } from 'notistack';
import {
  Grid,
  DialogActions,
  DialogContent,
  FormHelperText,
} from '@mui/material';
import { withStyles } from '@mui/styles';

// actions
import {
  fetchDAAgencies,
  addAgentToCluster,
} from '../../agencies/AgencyService';
// platform helpers
import { PubSub } from '../../utils/eventUtils';
import { reduceForAgenciesData } from '../../console/admin/users/userUtils';
// components
import { InputLabelBase } from '../inputs/InputLabelBase';
import CbButton from '../Buttons/CbButton';
import { ScrollableMultiSelect } from '../Selects/MultiSelect/ScrollableMultiSelect';
import { useCowbellTranslations } from '../../i18n/translations';
import { REDACTED_FIELD } from '../../config/logrocket';

const styles = ({ config, palette }: any) => {
  return {
    container: {
      marginBottom: '1rem',
    },
    label: {
      fontSize: config.textSizes.tertia,
      padding: 0,
    },
    value: {
      fontSize: config.textSizes.tertia,
      color: palette.primary.contrastText,
      fontWeight: config.weights.bold,
    },
  };
};

export const AddAgencyToCluster = withStyles(styles)(
  // @ts-expect-error TS(2339): Property 'classes' does not exist on type 'Consist... Remove this comment to see the full error message
  ({ classes, close, data }) => {
    const { enqueueSnackbar } = useSnackbar();
    const [error, setError] = useState('');
    const [agencies, setAgencies] = useState([]);
    const [totalPages, setTotal] = useState(1);
    const { t } = useCowbellTranslations();

    const {
      setValue,
      register,
      getValues,
      handleSubmit,
      formState: { isSubmitting },
    } = useForm({
      defaultValues: {
        selAgency: [],
      },
    });

    useEffect(() => {
      fetchDAAgencies()
        .then((resp: any) => {
          const result = reduceForAgenciesData(resp.data.content);
          setAgencies(result);
          setTotal(resp.data.totalPages);
        })
        .catch((error: any) => {
          setError(
            _.get(
              error.response,
              'data.message',
              _.get(error.response, 'data', 'Not able to fetch list.')
            )
          );
        });
      // eslint-disable-next-line
    }, []);

    const onAgencyChange = (name: any, selection: any) => {
      setError('');
      setValue(name, selection);
    };

    const onSubmit = ({ selAgency }: any) => {
      const { id } = data;

      if (!selAgency.value) {
        setError(`${t('agency')} must be selected.`);
      } else {
        setError('');

        return addAgentToCluster(id, selAgency.value)
          .then(() => {
            enqueueSnackbar(
              `${t('agency')} '${selAgency.label}' added to the cluster.`,
              { variant: 'success' }
            );
            close();
            PubSub.publish('table-refetch', 'clusters');
          })
          .catch((error) => {
            const message = `An error occurred! Please try again`;
            setError(
              _.get(
                error.response,
                'data.message',
                _.get(error.response, 'data', message)
              )
            );
          });
      }
    };

    const values = getValues();

    return (
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogContent>
          <Grid container className={classes.container}>
            <Grid item md={4}>
              <InputLabelBase required className={classes.label}>
                Select {t('agency')}
              </InputLabelBase>
            </Grid>
            <Grid item md={8}>
              <div className={classes.value}>
                <ScrollableMultiSelect
                  // @ts-expect-error TS(2783): 'name' is specified more than once, so this usage ... Remove this comment to see the full error message
                  name="selAgency"
                  buttonPlaceholder={`Select ${t('agency')}`}
                  {...register('selAgency')}
                  onChange={onAgencyChange}
                  // @ts-expect-error TS(2339): Property 'selectedAgencies' does not exist on type... Remove this comment to see the full error message
                  value={values.selectedAgencies}
                  options={agencies}
                  isMulti={false}
                  classes={{
                    select: classes.select,
                    icon: classes.selectIcon,
                  }}
                  api={fetchDAAgencies}
                  totalPages={totalPages}
                  reduceFunc={reduceForAgenciesData}
                  className={REDACTED_FIELD}
                />
              </div>
            </Grid>
          </Grid>
          {error && (
            <FormHelperText className="api-text-error">{error}</FormHelperText>
          )}
        </DialogContent>
        <DialogActions>
          <CbButton buttonText="Cancel" action={close} styleName="cancel" />
          <CbButton
            buttonText={`Add ${t('agency')}`}
            type="submit"
            loading={isSubmitting}
            disabled={isSubmitting}
            styleName="ctaButton"
          />
        </DialogActions>
      </form>
    );
  }
);

export default AddAgencyToCluster;
